import { render, staticRenderFns } from "./PatientWelcomeDisplay.vue?vue&type=template&id=d3a2e2ac&scoped=true"
import script from "./PatientWelcomeDisplay.vue?vue&type=script&lang=js"
export * from "./PatientWelcomeDisplay.vue?vue&type=script&lang=js"
import style0 from "./PatientWelcomeDisplay.vue?vue&type=style&index=0&id=d3a2e2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a2e2ac",
  null
  
)

export default component.exports